import dayjs from 'dayjs'
import { dateFormat } from '../../ResidentProfileScreen/utils/utils'

export const formatDate = (date: string | undefined | null): string => {
  if (!date) return ''
  return dayjs(date.trim(), 'YYYY-MM-DD').format(dateFormat)
}
